import Stripe from "./stripe"
import Tracking from "./tracking"
import Scroll from "./scroll"
import Format from "./format"
import TextSearch from "./textSearch"
import Payrexx from "./payrexx";

export default {
  Scroll,
  Stripe,
  Tracking,
  Format,
  TextSearch,
  Payrexx
}